import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { apiErrorMessage } from './api-error-message';

@Injectable()
export abstract class BaseAPIService {

    // set common API parameters
    constructor() {}

    // handle error and return a formatted message
    handleError(error: HttpErrorResponse | any) {
        return throwError(() => apiErrorMessage(error));
    }

    returnError(error: HttpErrorResponse | any) {
        return throwError(() => error);
    }

}
